import React, { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { auth, firestore } from "./firebase";
import { collection, doc, getDoc, updateDoc, addDoc } from "firebase/firestore";
import "./VerifyPin.css";
import Lock from '../src/assets/SignUpIcon/unlock.svg'
import Binn from '../src/assets/SignUpIcon/bin.svg'
import Keyy from '../src/assets/SignUpIcon/key.svg'
import Verii from '../src/assets/SignUpIcon/veri.png'




const VerifyPinTransfer = () => {
  const [pin, setPin] = useState("");
  const [error, setError] = useState("");
  const navigate = useNavigate();
  const location = useLocation();
  const transferDetails = location.state?.transferDetails || {};

  const handlePinSubmit = async (e) => {
    e.preventDefault();
    const user = auth.currentUser;
    if (!user) {
      navigate("/");
      return;
    }

    try {
      const userDoc = await getDoc(doc(firestore, "users", user.uid));
      if (userDoc.exists() && userDoc.data().pin === pin) {
        const walletBalance = userDoc.data().balance || 0;
        if (transferDetails.amount > walletBalance) {
          setError("Insufficient balance to complete this transfer.");
          return;
        }

        await updateDoc(doc(firestore, "users", user.uid), {
          balance: walletBalance - transferDetails.amount,
        });

        await addDoc(collection(firestore, "transactions"), {
          userId: user.uid,
          recipientEmail: transferDetails.recipientEmail,
          amount: transferDetails.amount,
          description: transferDetails.description || 'Transfer',
          title: transferDetails.title || 'Transfer',
          type: transferDetails.type || 'expense',  // Assuming transfer is always an expense
          name: transferDetails.name || 'Transfer',  // Assuming transfer is always an expense
          date: new Date(),
        });

        navigate("/transfer-success", {
          state: {
            recipientEmail: transferDetails.recipientEmail,
            amount: transferDetails.amount.toLocaleString(),
          },
        });
      } else {
        setError("Incorrect PIN");
      }
    } catch (error) {
      console.error("Error verifying PIN:", error);
      setError("An error occurred. Please try again.");
    }
  };

  const handleKeyClick = (value) => {
    if (pin.length < 4) {
      setPin(pin + value);
    }
  };

  const handleDelete = () => {
    setPin(pin.slice(0, -1));
  };

  return (
    <div className="verify-pin-container">
            <div className="VerifyTop">
        <div className="lockBox">
        <img style={{width: 36}} src={Lock} alt="" />
        </div>
      <h2 style={{marginBottom: 2,}} >Enter Passcode  </h2>
      
      </div>

      {transferDetails.description && (
        <div className="transaction-detailss">
          
          <div className="transferDetailss">
          <p className="transferBold">Type: </p>
          <p>
          {transferDetails.name}
          </p>
          </div>

          <div className="transferDetailss">
          <p className="transferBold">Receiver Email </p>
          <p>
          {transferDetails.recipientEmail}
          </p>
          </div>

          <div className="transferDetailss">
          <p className="transferBold" >Transfer Amount </p>
          <p className="transferBoldPrice" >
          ${parseFloat(transferDetails.amount).toLocaleString()}
          </p>
          </div>
        
          <div className="transferDetailss push">
          <p className="transferBold" >Reference </p>
          <p>
          {transferDetails.description}
          </p>
          </div>

          

         

          <div className="transferDetailss">
          <p className="transferBold">Narrator: </p>
          <p>
          {transferDetails.title}
          </p>
          </div>

        

          
      
          <p className="securett" style={{ fontSize: 13,}} >
       secured by UBS banking service <img style={{width: 15}} src={Lock} alt="" />
       <img style={{width: 14, marginLeft: 4,}} src={Verii} alt="" />
      </p>
        </div>
      )}


      <form onSubmit={handlePinSubmit}>
        <input placeholder="****" className="inputter" type="password" value={pin} readOnly />
        {error && <p className="error">{error}</p>}
        <div className="custom-keyboard">
          {[1, 2, 3, 4, 5, 6, 7, 8, 9].map((num) => (
            <button
              type="button"
              key={num}
              onClick={() => handleKeyClick(num.toString())}
            >
              {num}
            </button>
          ))}
          <button type="button" onClick={handleDelete}>
          <img style={{width: 26}} src={Binn} alt="" />
          </button>
          <button type="button" onClick={() => handleKeyClick("0")}>
            0
          </button>
          <button style={{backgroundColor: '#000000', color: '#f5f6f7', fontSize: 17, textAlign: 'center', alignItems: 'center', justifyContent: 'center'  }} type="submit">Enter</button>
          
          
            </div>
      </form>
      
    </div>
  );
};

export default VerifyPinTransfer;
